import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material'
import React from 'react'
import MainContainer from 'theme/MainConatiner'
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import CategoryCard from 'components/CategoryCard/CategoryCard';
import CategoryCardSkeleton from 'components/CategoryCard/CategoryCardSkeleton';
import NoSearchFound from 'components/NoSearchFound/NoSearchFound';
import StationCard from 'components/CategoryCard/StationCard';

const StationsContainer = ({
    stationsData,
    setSearchQuery,
    searchTxt,
    handleAddBtn,
    loading,
    error,
    handleEdit,
    handleDelete,
    handleAssignBtn
}) => {
    const PLACEHOLDER_COUNT = 6;
    const hasData = !loading && stationsData?.length > 0;
    const showNoItems = !loading && stationsData?.length === 0;
    const itemsToRender = loading ? Array.from({ length: PLACEHOLDER_COUNT }) : stationsData;
    const isSearching = searchTxt.trim().length > 0

    return (
        <MainContainer>
            <Card className='main-card-container'>
                <HeaderTilteBar
                    title={"Stations"}
                    isSearch={stationsData?.length > 0 || isSearching}
                    btnText={"Add New"}
                    btnIcon={true}
                    onSearchChange={setSearchQuery}
                    searchQuery={searchTxt}
                    handleAddBtn={handleAddBtn}
                // handleBack={handleBack}
                />


                {showNoItems && (
                    <Box className='body-wrapper'>
                        {isSearching ? (
                            <NoSearchFound
                                title="No Stations matches your search"
                                subtitle={`Please try again with a different keyword to get result..`}
                            />
                        ) : (
                            <NoItemsCreated
                                title="No Stations Created Yet!"
                                subtitle="Add your first station."
                            />
                        )}
                    </Box>
                )}

                {!showNoItems && (
                    <Box sx={{ mt: 1 }}>
                        <Grid container spacing={2}>
                            {itemsToRender?.map((cat, idx) => (
                                <Grid item xs={12} sm={6} md={4} key={cat?.id ?? idx}>
                                    {loading ? (
                                        <CategoryCardSkeleton />
                                    ) : (
                                        <StationCard
                                            title={cat.name}
                                            description={cat.notes}
                                            enabled={cat.active_status}
                                            onEdit={() => handleEdit(cat)}
                                            onDelete={() => handleDelete(cat)}
                                            isSwitch={false}
                                            isCount={true}
                                            itemCount={cat?.chefs?.length || 0}
                                            // handleAssignChefs={handleAssignBtn}
                                            handleAssignChefs={() => handleAssignBtn(cat)}   // ✅ pass station data
                                        />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            </Card>
        </MainContainer>
    )
}

export default StationsContainer
